<template>
  <v-data-table
    v-bind="$attrs"
    v-on="$listeners"

    :headers="headers"
    item-key="_id"
  >
    <template v-slot:item.quantity="{ item }">
      <span :class="{ 'error--text': item.quantity < 0 }">
        {{ formatNumber(item.quantity) }}
      </span>
    </template>

    <template v-slot:item.unitaryPrice="{ item }">
      {{ formatCurrency(item.unitaryPrice) }}
    </template>

    <template v-slot:item.value="{ item }">
      <span :class="{ 'error--text': item.value < 0 }">
        {{ formatCurrency(item.value) }}
      </span>
    </template>

    <template v-slot:item.mtd="{ item }">
      <span :class="{ 'error--text': item.mtd < 0 }">
        {{ formatPerformance(item.mtd) }}
      </span>
    </template>

    <template v-slot:item.ytd="{ item }">
      <span :class="{ 'error--text': item.ytd < 0 }">
        {{ formatPerformance(item.ytd) }}
      </span>
    </template>

    <template v-slot:item.percValue="{ item }">
      <span :class="{ 'error--text': item.percValue < 0 }">
        {{ formatPercentage(item.percValue) }}
      </span>
    </template>
  </v-data-table>
</template>

<script>
import { formatCurrency, formatNumber, formatPercentage } from '@/utils/format-utils';

export default {
  name: 'HoldingSharesTable',

  inheritAttrs: false,

  data: () => ({
    headers: [
      {
        value: 'ticker',
        text: 'Ativo',
      },

      {
        value: 'book',
        text: 'Book',
      },

      {
        value: 'quantity',
        text: 'Quantidade',
        align: 'end',
      },

      {
        value: 'unitaryPrice',
        text: 'PU de Mercado',
        align: 'end',
      },

      {
        value: 'value',
        text: 'Valor de Mercado',
        align: 'end',
      },

      {
        value: 'mtd',
        text: 'MTD',
        align: 'end',
      },

      {
        value: 'ytd',
        text: 'YTD',
        align: 'end',
      },

      {
        value: 'percValue',
        text: '%PL',
        align: 'end',
      },
    ],
  }),

  methods: {
    formatCurrency,
    formatNumber,
    formatPercentage,
    formatPerformance: (val) => formatPercentage(val, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  },
};
</script>
